import { CurrencyRecord, SupportedCurrency } from '../domain/currency';
import { TransportOrder } from '../domain/transportOrder';

export const calculateProfitForCurrency = (transportOrder: TransportOrder, forCurrency: SupportedCurrency, currencyRecord: CurrencyRecord) => {
    const freightValue = transportOrder.freight.value ?? '0';
    const clientValue = transportOrder.freight.clientValue ?? '0';

    if (isNaN(Number(freightValue)) || isNaN(Number(clientValue))) {
        return 0;
    }

    const { freight } = transportOrder;
    const clientCurrency = freight.clientCurrency;

    // If the target currency is the same as client currency, we only need to convert the value
    if (forCurrency === clientCurrency) {
        if (forCurrency === freight.currency) {
            return Number(clientValue) - Number(freightValue);
        }

        // client currency is as expected but contractor pays in different one
        const currencyRate = currencyRecord[forCurrency];
        const convertedContractorValue = Number(freightValue) / currencyRate.exchangeRate;

        return Number(clientValue) - convertedContractorValue;
    }

    const convertedClientValue = Number(clientValue) / currencyRecord[forCurrency].exchangeRate;
    const convertedContractorValue = freight.currency === forCurrency ? Number(freightValue) : Number(freightValue) / currencyRecord[forCurrency].exchangeRate;


    return convertedClientValue - convertedContractorValue;
};